// @flow
import { APICore } from "./apiCore";

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllPromo(params: any): any {
  const baseUrl = "/api/admin/promo";
  return api.get(`${baseUrl}`, params);
}

// function ApiGetReportFasilitas(params: any): any {
//     const baseUrl = '/api/admin/fasilitas_order';
//     return api.get(`${baseUrl}`, params);
// }

function ApiPostPromo(params: any): any {
  const baseUrl = "/api/admin/promo";
  // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
  return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditPromo(params, id) {
  const baseUrl = "/api/admin/promo/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiDeletePromo(id) {
  const baseUrl = "/api/admin/promo/" + id;
  return api.delete(`${baseUrl}`);
}

export {
  // ApiGetAllKategoriMenu,
  ApiGetAllPromo,
  // ApiGetReportFasilitas,
  // ApiPostCategoryRoom,
  ApiPostPromo,
  // ApiEditKategoriRoom,
  ApiEditPromo,
  // ApiDeleteKategoriRoom,
  ApiDeletePromo,
};
